import { useStoryblok } from '@storyblok/react';
import { useTranslation } from 'react-i18next';

const useStoryblokConfig = () => {
  const { i18n } = useTranslation();
  const locale = i18n.language;

  const version = (process.env.REACT_APP_STORYBLOK_VERSION as 'draft' | 'published') || 'draft';

  const settings = useStoryblok('settings', {
    version,
    language: locale === 'de' ? '' : locale, // Not passing an explicit locale for 'de'
  });

  return settings ? settings.content : null;
};

export default useStoryblokConfig;
